<template>
    <div class="stripe-reader-cta-container mt-4">
        <p v-if="discoveredReaders || connectedReader" v-text="readerCopy"></p>
        <div v-if="!isDeviceConnected">
            <radio-field
            v-for="(item, index) in discoveredReaders"
            :key="index"
            v-model="selectedReader"
            :option="item.id"
            :label="item.label"/>
        </div>
        <submit-button
            v-if="!isDeviceConnected"
            :processing="isConnectingToReader"
            color="green"
            @click="readerHandler"
            v-text="readerBtnCopy"/>
        <p v-if="cardDetails" v-text="$t('CARD_DETAILS')"></p>
        <submit-button v-if="isDeviceConnected" color="green" @click="disconnectReader" v-text="$t('DISCONNECT_READER')"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import UserService from '@/services/users/UserService';
import RadioField from '@/components/forms/fields/RadioField';

export default {
    name: 'StripeTerminalReader',
    components: {
        RadioField,
        SubmitButton,
    },
    data() {
        return {
            stripeTerminal: null,
            selectedReader: null,
        };
    },
    computed: {
        ...mapGetters({
            discoveredReaders: 'canvasser/getDiscoveredReaders',
            isConnectingToReader: 'canvasser/isConnectingToReader',
            connectedReader: 'canvasser/getConnectedReader',
            connectionStatus: 'canvasser/getConnectionStatus',
            getSelectedReader: 'canvasser/getSelectedReader',
            cardDetails: 'canvasser/getCardDetails',
            isCanvasser: 'auth/isCanvasser',
        }),
        readerBtnCopy() {
            return !this.discoveredReaders ? this.$t('DISCOVER_READER') : this.$t('CONNECT_READER');
        },
        readerCopy() {
            return this.connectedReader ? `Connected to: ${this.getSelectedReader?.label}` : 'Device Found: ';
        },
        isDeviceConnected() {
            return (this.connectionStatus && this.connectionStatus.toLowerCase() === 'connected') || (this.discoveredReaders && this.connectedReader);
        },
    },
    mounted() {
        !this.isDeviceConnected && this.isCanvasser && this.initialiseStripeSDK();
    },
    methods: {
        ...mapActions({
            discoverReaderHandler: 'canvasser/discoverStripeTerminalReader',
            connectReaderHandler: 'canvasser/connectReaderHandler',
            disconnectReader: 'canvasser/disconnectReader',
            collectCardDetails: 'canvasser/collectCardDetails',
        }),
        async fetchStripeTerminalToken() {
            let service = new UserService();
            let stripeTerminalToken = await service.fetchStripeTerminalToken();
            return stripeTerminalToken.data.secret;
        },
        unexpectedDisconnect() {
            this.discoverReaderHandler();
        },
        initialiseStripeSDK() {
            this.stripeTerminal = StripeTerminal.create({
                onFetchConnectionToken: this.fetchStripeTerminalToken,
                onUnexpectedReaderDisconnect: this.unexpectedDisconnect,
            });
            this.$store.commit('canvasser/setConnectionStatus', this.stripeTerminal.connectionStatus);
            this.$store.commit('canvasser/setStripeTerminal', this.stripeTerminal);
        },
        readerHandler() {
            return !this.discoveredReaders ? this.discoverReaderHandler() : this.connectReaderHandler();
        },
    },
    watch: {
        connectionStatus: {
            handler: function(connectionStatus) {
                if (connectionStatus === 'not_connected') {
                    this.initialiseStripeSDK();
                    this.$store.commit('canvasser/setDiscoveredReaders', null);
                    this.$store.commit('canvasser/setConnectedReader', null);
                }
            },
            deep: true,
        },
        selectedReader(value) {
            let selectReader = this.discoveredReaders.find(item => item.id === value);
            this.$store.commit('canvasser/setSelectedReader', selectReader);
        },
    },
};
</script>

<style scoped>
    .stripe-reader-cta-container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
